import React from 'react'
import clsx from 'clsx'
import { observer } from 'mobx-react'
import { IconButton, Marker } from '@instacart/tds'
import { CloseIcon } from '@instacart/ids-core'
import { useRouteMatch } from 'react-router-dom'
import { useActionFlow } from '~shared/lib/ActionFlow'
import catalogStore from '../../../Stores/CatalogStore'
import { FetchStatus } from '~shared/lib/Types/FetchTypes'
import styles from '../ManageMenuModal.module.scss'

export const ManageMenuHeader: React.FC = observer(() => {
  const { close } = useActionFlow()
  const itemMatch = useRouteMatch<{ itemId: string }>('/item/:itemId')
  const itemId = itemMatch?.params?.itemId

  const item = itemId ? catalogStore.catalogTree.find(i => i.ItemUid === itemId) : undefined

  const hasCachedData = catalogStore.catalogFetch.data !== undefined
  const isFetching = catalogStore.catalogFetch.status === FetchStatus.fetching
  const isRefreshing = isFetching && hasCachedData

  const title = itemId ? (item?.Name ?? 'Details') : 'Manage Menu'
  const showMarker = itemId && item

  return (
    <div className={styles.dialogHeader}>
      <div className={styles.dialogHeaderLeft}>
        <h3 className={clsx(!itemId && styles.dialogHeaderTitle, isRefreshing && styles.pulsing)}>
          {title}
        </h3>

        {showMarker ? (
          <Marker
            text={item.IsAvailableToday ? 'Available' : 'Unavailable'}
            variant={item.IsAvailableToday ? 'success' : 'detrimental'}
          />
        ) : null}

        {isRefreshing && <div className={clsx('fs-loading-small', styles.headerSpinner)} />}
      </div>

      <IconButton
        data-testid="manage-menu-close"
        onClick={close}
        className={styles.dialogClose}
        variant="secondary"
        icon={CloseIcon}
      />
    </div>
  )
})
